const ExternalServicesIcon = (
  <svg
    className="fill-current"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17 2a5 5 0 0 1 4.899 6.317A7.5 7.5 0 0 1 17 21H7a5 5 0 1 1 0-10h.26A7.001 7.001 0 0 1 10 3.05V3a5 5 0 0 1 7-1ZM7 13H6a3 3 0 1 0 0 6h11a5.5 5.5 0 0 0 1.178-10.85 1 1 0 0 1-.63-1.1A3 3 0 0 0 17 4a3 3 0 0 0-3 3v1a1 1 0 0 1-1 1 5 5 0 0 0-5 5v.172A3.001 3.001 0 0 0 7 13Z" />
  </svg>
);

export default ExternalServicesIcon;
